export default __webpack_public_path__ + "static/media/logo.7ac96923.svg";